import { ImageWithPlaceholder } from '@/app/components/shared/ImageWithPlaceholder';
import { cn } from '@/app/utils';

/**
 * 展示图片或视频，contain 的时候使用 maskSrc 作为模糊背景填充，视频默认自动播放
 */
export const MediaWithMaskBg = ({
  src,
  maskSrc,
  className,
  imgClassName,
  alt = '',
  disableDownload = false,
  disableDrag = false,
  useCover = false,
  videoAutoPlay = true,
  type = 'image',
  onClick,
  videoCoverImage,
  fullScreen = false,
  fullScreenWatermark = false,
}: {
  src?: string;
  maskSrc?: string;
  className?: string;
  imgClassName?: string;
  alt?: string;
  disableDownload?: boolean;
  /** 是否禁用拖拽 */
  disableDrag?: boolean;
  /** 是否使用 object-cover 模式（裁剪）而不是 object-contain（完整显示） */
  useCover?: boolean;
  /** 是否自动播放视频 */
  videoAutoPlay?: boolean;
  type?: 'image' | 'video';
  onClick?: () => void;
  videoCoverImage?: string;
  fullScreen?: boolean;
  fullScreenWatermark?: boolean;
}) => {
  const resolvedSrc = src || null;

  return (
    <div
      className={cn(
        "relative h-full translate-y-0 overflow-hidden bg-[#343C48] before:absolute before:inset-0 before:z-[-1] before:scale-[2.5] before:bg-center before:bg-cover before:bg-dynamic before:bg-no-repeat before:opacity-48 before:blur-[30px] before:content-['']",
        className,
      )}
      style={
        maskSrc
          ? ({
              '--bg-image-url': `url(${maskSrc})`,
            } as React.CSSProperties)
          : undefined
      }
      onClick={onClick}
    >
      {type === 'video' ? (
        resolvedSrc ? (
          <video
            src={resolvedSrc}
            poster={videoCoverImage}
            className={cn('h-full w-full', useCover ? 'object-cover' : 'object-contain', imgClassName)}
            autoPlay={videoAutoPlay}
            muted
            loop
            playsInline
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
          />
        ) : (
          <div className={cn('h-full w-full', imgClassName)} />
        )
      ) : resolvedSrc ? (
        <ImageWithPlaceholder
          src={resolvedSrc}
          alt={alt}
          className={cn(
            'h-full w-full',
            useCover ? 'object-cover' : 'object-contain',
            disableDownload && 'select-none',
            imgClassName,
          )}
          fullScreen={fullScreen}
          fullScreenWatermark={fullScreenWatermark}
          disableDownload={disableDownload}
          draggable={disableDrag ? false : !disableDownload}
          onDragStart={disableDrag ? (e) => e.preventDefault() : undefined}
        />
      ) : (
        <div className={cn('h-full w-full', imgClassName)} />
      )}
    </div>
  );
};
